import React from "react";

const ProductSeoContent = () => {
  return (
    <section className="landing-seo-content" aria-label="eSyncing product catalog">
      <h2>eSyncing Product Catalog</h2>
      <p>
        eSyncing provides a suite of AI-powered products for interactive demos,
        team communication, knowledge access, workflow support, and connected
        digital experiences.
      </p>

      <h3>Interactive Product Demos</h3>
      <p>
        Interactive Product Demos help companies show software product flows
        without scheduling meetings. Users can explore guided experiences, see
        features in context, and learn products through hands-on interaction.
      </p>

      <h3>AI-Powered Chat for Teams and Customers</h3>
      <p>
        AI chat enables real-time communication for customer support, internal
        collaboration, and AI-assisted conversations. It supports faster
        responses, shared context, and improved service workflows.
      </p>

      <h3>Virtual HR Assistant</h3>
      <p>
        The Virtual HR Assistant helps employees get answers to HR policies,
        rules, and internal questions using company knowledge and AI-assisted
        support.
      </p>

      <h3>Company Knowledge Hub</h3>
      <p>
        The Knowledge Hub centralizes documents, policies, guides, and learning
        resources. Teams can search knowledge quickly and reduce time spent
        asking repetitive internal questions.
      </p>

      <h3>Integrations</h3>
      <p>
        eSyncing integrations connect messaging, documents, email, and other
        business tools so organizations can use AI and communication workflows
        across platforms without switching systems.
      </p>

      <h3>Industry Use Cases</h3>
      <p>
        eSyncing supports industries including SaaS, customer support,
        internal operations, education, real estate, e-commerce, and
        enterprise teams that need better communication and knowledge systems.
      </p>
    </section>
  );
};

export default ProductSeoContent;
